import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vAllProjectBase {

//#region projectId Prop
        @gridColumn({ visible: false, columnIndex: 0, allowSorting: true, headerKey: 'projectId', keyColumn: true })
        projectId : number;
//#endregion projectId Prop


//#region projectName Prop
        @gridColumn({ visible: true, columnIndex: 1, allowSorting: true, headerKey: 'projectName', headerTitle: 'Project Name', keyColumn: false })
        projectName : string;
//#endregion projectName Prop


//#region createdOn Prop
        @gridColumn({ visible: false, columnIndex: 3, allowSorting: true, headerKey: 'createdOn', headerTitle: 'Created On', keyColumn: false })
        createdOn : any;
//#endregion createdOn Prop

}